import React from 'react'
import TablePagination from '@mui/material/TablePagination'
import { styled } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

const ResponsiveTablePagination = styled(TablePagination)(({ theme }) => ({
	'& .MuiTablePagination-toolbar': {
		flexWrap: 'wrap',
		minHeight: '52px',
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		justifyContent: 'flex-end',

		[theme.breakpoints.down('sm')]: {
			paddingLeft: theme.spacing(0.5),
			paddingRight: theme.spacing(0.5),
			minHeight: 'auto',
			justifyContent: 'center',
			rowGap: theme.spacing(1),
		},
	},

	'& .MuiTablePagination-spacer': {
		flex: 'none',
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},

	'& .MuiTablePagination-selectLabel': {
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.75rem',
			margin: 0,
			marginRight: theme.spacing(1),
		},
	},

	'& .MuiTablePagination-selectRoot': {
		[theme.breakpoints.down('sm')]: {
			marginRight: 0,
			flexBasis: '100%',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
	},

	'& .MuiTablePagination-select': {
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.75rem',
			paddingRight: '20px',
		},
	},

	'& .MuiTablePagination-displayedRows': {
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.75rem',
			margin: 0,
			marginRight: theme.spacing(1),
		},
	},

	'& .MuiTablePagination-actions': {
		[theme.breakpoints.down('sm')]: {
			marginLeft: 0,
		},
	},

	'& .MuiIconButton-root': {
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(0.5),
		},
	},
}))

const CustomTablePagination = ({
	page = 0,
	rowsPerPage = 10,
	totalCount = 0,
	handleChangePage = () => {},
	handleChangeRowsPerPage = () => {},
	...rest
}) => {
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	return (
		<ResponsiveTablePagination
			component="div"
			count={totalCount}
			page={page}
			onPageChange={handleChangePage}
			rowsPerPage={rowsPerPage}
			onRowsPerPageChange={handleChangeRowsPerPage}
			labelRowsPerPage={isMobile ? 'Rows:' : 'Rows per page:'}
			{...rest}
		/>
	)
}

export default React.memo(CustomTablePagination)